import React from 'react';

export function RecordHeader({ t }) {
  return (
    <div className="record-header">
      <h1>{t('creationRecord.title')}</h1>
      <p>{t('creationRecord.description')}</p>
    </div>
  );
}

export function FilterTabs({ filter, stats, t, onFilter, onRefresh }) {
  return (
    <div className="filter-tabs">
      <FilterButton active={filter === 'all'} onClick={() => onFilter('all')}>
        {t('creationRecord.all')} ({stats.total})
      </FilterButton>
      <FilterButton active={filter === 'completed'} onClick={() => onFilter('completed')}>
        {t('creationRecord.completed')} ({stats.completed})
      </FilterButton>
      <FilterButton active={filter === 'processing'} onClick={() => onFilter('processing')}>
        {t('creationRecord.processing')} ({stats.processing})
      </FilterButton>
      <button className="refresh-btn" onClick={onRefresh} title={t('common.refresh', 'Refresh')}>
        <RefreshIcon />
      </button>
    </div>
  );
}

export function EmptyState({ t, onCreate }) {
  return (
    <div className="empty-state">
      <div className="empty-icon">📝</div>
      <h3>{t('creationRecord.noRecordsFound')}</h3>
      <p>{t('creationRecord.noRecordsDescription')}</p>
      <button className="btn-create" onClick={onCreate}>{t('creationRecord.startCreating')}</button>
    </div>
  );
}

export function LoadingState({ t }) {
  return (
    <div className="loading-container">
      <div className="loading-spinner"></div>
      <p>{t('creationRecord.loading')}</p>
    </div>
  );
}

function FilterButton({ active, children, onClick }) {
  return (
    <button className={active ? 'active' : ''} onClick={onClick}>
      {children}
    </button>
  );
}

function RefreshIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M23 4v6h-6M1 20v-6h6" />
      <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
    </svg>
  );
}
